var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-800"},[_c('img',{attrs:{"src":_vm.image,"id":"screen-image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }